
































import { Vue, Component, Prop } from 'vue-property-decorator';
import AccordionItem from '@/models/AccordionItem';

@Component
export default class Accordion extends Vue {
  @Prop() private children!: Array<AccordionItem>;
  private whoIsOpen: number = -1;
  private timeupdate: any;
  private disableTransition: boolean = false;
  private accordionButtonsElements: any = {};
  private accordionButtonsElementsIds: any = [];
  public $refs!: {
    accordionWrapper: HTMLFormElement;
  };
  private accordionHeight: number = 0;

  private open(index: number) {
    this.whoIsOpen = index == this.whoIsOpen ? -1 : index;
  }

  private isOpen(index: number): string {
    return this.whoIsOpen == index ? 'opened' : 'closed';
  }

  private preventScroll(e: any) {
    e.target.scrollTop = 0;
  }

  private mounted() {
    setTimeout(() => {
      this.updateAccordionHeight();
      this.whoIsOpen = 0;
    }, 0);
    window.addEventListener('resize', this.updateAccordionHeight);
    this.accordionButtonsElementsIds = [
      ...this.$refs.accordionWrapper.getElementsByClassName(
        'accordion-item-container'
      )
    ].map(item => {
      this.accordionButtonsElements[item.id] = item.getElementsByClassName(
        'title'
      )[0];
      return item.id;
    });
  }
  private beforeDestroy() {
    window.removeEventListener('resize', this.updateAccordionHeight);
  }
  private updated() {
    this.updateAccordionHeight();
  }

  private updateAccordionHeight() {
    clearTimeout(this.timeupdate);
    this.disableTransition = true;
    this.accordionHeight = this.$refs.accordionWrapper.offsetHeight;

    this.timeupdate = setTimeout(() => {
      this.disableTransition = false;
    }, 200);
  }
  private handleArrow(direction: number) {
    if (document.activeElement && document.activeElement.parentElement) {
      let currentId = document.activeElement.parentElement.id;
      let currentIndex = this.accordionButtonsElementsIds.indexOf(currentId);
      if (currentIndex > -1) 
        this.focusOnNextElement(direction, currentIndex);
      
    }
  }

  private focusOnNextElement(direction: number, currentIndex: number) {
    let nextIndex = this.getNextIndex(
      direction,
      currentIndex,
      this.accordionButtonsElementsIds.length
    );
    let nextElement = this.getAccordionButtonsElementsByIndex(nextIndex);
    nextElement.focus();
  }

  private getNextIndex(
    direction: number,
    currentIndex: number,
    totalItens: number
  ): number {
    if (currentIndex === totalItens - 1 && direction > 0) 
      currentIndex = 0;
    else 
    if (currentIndex == 0 && direction < 0) 
      currentIndex = totalItens - 1;
    else 
      currentIndex += direction;
      
    
    return currentIndex;
  }

  public getAccordionButtonsElementsByIndex(index: number): HTMLElement {
    return this.accordionButtonsElements[
      this.accordionButtonsElementsIds[index]
    ];
  }
}
